import axios from 'axios';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
// // redirect to login page whenever token is no longer valid
// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response.status === 401) {
//       console.log('validated');
//       store.dispatch('users/setUnauthenticated');
//       this.$router.push('/login');
//     }
//     return Promise.reject(error);
//   },
// );

export default {
  namespaced: true,
  state: {
    blogs: [],
    detailedBlog: null,
  },
  mutations: {
    updateBlogs(state, newBlogs) {
      state.blogs = newBlogs;
    },
    updateDetailedBlog(state, newBlog) {
      state.detailedBlog = newBlog;
    },
  },
  actions: {
    retrieveBlogs(context, pageNumber) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/blog/blogs/?page=${pageNumber}`,
          method: 'get',
        }).then((response) => {
          context.commit('updateBlogs', response.data);
          console.log(response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateBlogs', []);
          reject(error);
        });
      });
    },
    retrieveDetailedBlog(context, blogSlug) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/blog/blog/${blogSlug}/`,
          method: 'get',
        }).then((response) => {
          context.commit('updateDetailedBlog', response.data);
          resolve(response);
        }).catch((error) => {
          context.commit('updateDetailedBlog', null);
          reject(error);
        });
      });
    },
  },
  getters: {
    getBlogs(state) {
      return state.blogs;
    },
    getDetailedBlog(state) {
      return state.detailedBlog;
    },
  },
};
